import { connect, MapStateToProps } from 'react-redux'
import { Props } from './EquipmentSearchFilter'
import { State } from '../../redux/reducers/rootReducer'
import { setTextFilter } from '../../redux/actions/app/equipmentFilter.actions'
import { setGlobalEquipmentSearchQuery, setSearchMode } from '../../redux/actions/app/equipmentGlobalSearch.actions'
import filterTextEquipmentSelector from '../../redux/selectors/equipments/filterTextEquipmentSelector'
import equipmentGlobalSearchResultsSelector from '../../redux/selectors/globalSearch/globalEquipmentSearchResultsSelector'
import globalEquipmentSearchModeSelector from '../../redux/selectors/globalSearch/globalEquipmentSearchModeSelector'
import { globalSearchQuerySelector } from '../../redux/selectors/globalSearch/globalEquipmentSearchResultsSelector'

type StateProps = Pick<Props, 'value' | 'equipmentGlobalSearchResults' | 'searchMode' | 'globalSearchQuery'>

const mapStateToProps: MapStateToProps<StateProps, {}, State> = (state): StateProps => ({
    value: filterTextEquipmentSelector(state),
    equipmentGlobalSearchResults: equipmentGlobalSearchResultsSelector(state),
    searchMode: globalEquipmentSearchModeSelector(state),
    globalSearchQuery: globalSearchQuerySelector(state),
})

type DispatchProps = Pick<Props, 'setFilter' | 'setEquipmentGlobalSearchQuery' | 'setSearchMode'>

const mapDispatchToProps: DispatchProps = {
    setFilter: setTextFilter,
    setEquipmentGlobalSearchQuery: setGlobalEquipmentSearchQuery,
    setSearchMode: setSearchMode,
}

export default connect(mapStateToProps, mapDispatchToProps)
